import React, { useState } from 'react';
import { Card, Space } from 'antd';
import CampaignRequestorTagsDialog from './CampaignRequestorTagsDialog';
import CampaignRequestorLocationsDialog from './CampaignRequestorLocationsDialog';
import { CampaignRequestorKpiTable } from './CampaignRequestorKpiTable';

const eventTypeMap = {
  transactions: 'transactionsConfig',
  signups: 'signUpConfig',
  sessions: 'sessionConfig',
};

const CampaignRequestorAttributionReporting = ({ formValues, helpers, google }) => {
  // Extract reactive values
  const { geoTargets = [], attributionTargets = [], measureWalkInTraffic } = formValues;

  const [showTagsModal, setShowTagsModal] = useState(false);
  const [eventType, setEventType] = useState(null);
  const [showRetailStoresModal, setShowRetailStoresModal] = useState(false);

  const handleSelectMeasurementTag = (key) => {
    setEventType(key);
    setShowTagsModal(true);
  };

  const handleTagSelections = (eventTarget) => {
    try {
      const configValue = eventTarget
        ? {
            appId:
              eventTarget && eventTarget.eventTags && eventTarget.eventTags.length
                ? eventTarget.eventTags[0].appId
                : null,
            cartProvider: eventTarget.cart,
            traffId: null,
            gtmAccess: null,
            gtmStatus: null,
            tracksBasketItems: null,
            tag: {
              ...eventTarget.tag,
              name: eventTarget.name,
            },
          }
        : null;

      // Update the form field using the helper
      const fieldName = eventTypeMap[eventType];
      
      if (fieldName) {
        // Use setFieldsValue to avoid triggering handleValuesChange
        helpers.setFieldsValue({ [fieldName]: configValue });
      }
    } catch (error) {
      console.error('Error handling tag selections:', error);
    }
  };

  const handleLocationSelections = (targets) => {
    helpers.updateField('geoTargets', targets);
  };

  return (
    <>
      <Card id="requester-attribution-reporting" title="ATTRIBUTION REPORTING">
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <CampaignRequestorKpiTable
            form={helpers.form}
            editable={true}
            handleSelectMeasurementTag={handleSelectMeasurementTag}
            setPreviousValues={(values) => {
              // Convert legacy setPreviousValues to helper methods
              helpers.setFieldsValue(values);
            }}
            // Pass reactive form values to ensure re-renders
            transactionsConfig={formValues.transactionsConfig}
            signUpConfig={formValues.signUpConfig}
            sessionConfig={formValues.sessionConfig}
            awarenessCampaign={formValues.awarenessCampaign}
          />
        </Space>
      </Card>

      {showTagsModal && (
        <CampaignRequestorTagsDialog
          visible={showTagsModal}
          setVisible={setShowTagsModal}
          form={helpers.form}
          eventType={eventType}
          onAddSelections={handleTagSelections}
        />
      )}

      {showRetailStoresModal && (
        <CampaignRequestorLocationsDialog
          visible={showRetailStoresModal}
          setVisible={setShowRetailStoresModal}
          form={helpers.form}
          google={google}
          audienceType="ATTRIBUTION"
          onAddSelections={handleLocationSelections}
          selectedLocations={[
            ...geoTargets,
            ...(measureWalkInTraffic ? attributionTargets : []).map((target) => ({
              ...target,
              disabled: true,
            })),
          ]}
        />
      )}
    </>
  );
};

export default CampaignRequestorAttributionReporting;